import { createElement, Component, Fragment, Props as ReactProps, ChangeEvent } from "react";
import { DependencyProps } from '../../../../core/dependency';
import { LocationProps } from '../../../../core/location';
import { StateProps } from '../../../../core/state';
import * as _ from 'lodash';
import Product from "../../../../entity/product";
import OrderProduct from "../../../../entity/orderProduct";
import Order from "../../../../entity/order";

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps & {
    attrs?: any;
  };

type State = {
  manageId: string;
  product?: Product;
  orderProduct?: OrderProduct;
  order?: Order;
}

class ProductRoute extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      manageId: this.props.attrs && this.props.attrs['product-manage-id'].value || '',
    };

    this.autoSave = this.autoSave.bind(this);
    this.autoSave = _.debounce(this.autoSave, 500);
  }

  public componentWillMount() {
    this.initialize(this.props);
  }

  public render() {
    const {
      product,
      orderProduct,
    } = this.state;
    if (!product || !orderProduct) {
      return null;
    }

    return <Fragment>
      <img className='img' src={product.displayImage()} />
      <div className='price'>
        ¥{product.price + product.taxPrice}
      </div>
      <div className='title'>
        {product.displayTitle()}
      </div>
      <div className='desc'>
        {product.ecDescription}
      </div>
      <input defaultValue={orderProduct.count || 0}
             className='input'
             type='number'
             min={0}
             onChange={(e: ChangeEvent<HTMLInputElement>) => this.autoSave(e.target.value)}
      />
    </Fragment>;
  }

  private async initialize(props: Props) {
    try {
      const res = await props.dependency.buyProduct.initialize(this.state.manageId);
      this.setState({ ...res });
    } catch (err) {
      window.console.error(err);
    }
  }

  private async autoSave(count: string | number) {
    try {
      const { order, manageId } = this.state;
      if (!order || !order.id) {
        throw new Error('It is cannot have reach here.');
      }

      if (typeof count === 'string') {
        await this.props.dependency.buyProduct.saveCount(manageId, parseInt(count), order.id);
      } else {
        await this.props.dependency.buyProduct.saveCount(manageId, count, order.id);
      }
    } catch (e) {
      window.console.error(e);
    }
  }
}

export default ProductRoute;
